/**
 * Calcula el código AGE_RANGE a partir de una edad numérica
 * usando los códigos del catálogo (p. ej. "0-12", "13-19", "60+").
 */
export const getAgeRangeFromAge = (
  ageValue: string | number | null | undefined,
  options: Array<{ code: string; description: string }>
): string => {
  const age = typeof ageValue === 'number'
    ? ageValue
    : Number.parseInt(String(ageValue || '').trim(), 10);
  if (Number.isNaN(age) || age < 0) return '';

  for (const option of options) {
    const raw = String(option.code || option.description || '').trim();
    const between = raw.match(/^(\d+)\s*-\s*(\d+)$/);
    if (between) {
      const min = Number.parseInt(between[1], 10);
      const max = Number.parseInt(between[2], 10);
      if (!Number.isNaN(min) && !Number.isNaN(max) && age >= min && age <= max) {
        return option.code;
      }
    }

    const plus = raw.match(/^(\d+)\s*\+$/);
    if (plus) {
      const min = Number.parseInt(plus[1], 10);
      if (!Number.isNaN(min) && age >= min) {
        return option.code;
      }
    }
  }

  return '';
};

export const isValidAgeOneOrTwoDigits = (value: string): boolean => {
  const trimmed = (value || '').trim();
  if (!/^\d{1,2}$/.test(trimmed)) return false;
  const age = Number.parseInt(trimmed, 10);
  return !Number.isNaN(age) && age >= 0 && age <= 99;
};
